import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoUnUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoUnUseVO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly value: RoomBrandLogoUnUse) {
    JsonSchemaValidator.assert(RoomBrandLogoUnUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoUnUse {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
